export class CryptoTuple {
    tupleWasm;
    cryptoProvider;
    constructor(tupleWasm, cryptoProvider) {
        this.tupleWasm = tupleWasm;
        this.cryptoProvider = cryptoProvider;
    }
    async encrypt(decryptedTuple) {
        const crypto = await this.cryptoProvider.getCrypto();
        const encrypted = crypto.encryptLong(decryptedTuple);
        return this.tupleWasm.makeTupleFromBytesArray(encrypted);
    }
    async decrypt(encryptedTuple) {
        const encrypted = this.tupleWasm.getMultiStringFromTuple(encryptedTuple);
        const crypto = await this.cryptoProvider.getCrypto();
        return crypto.decryptLong(encrypted);
    }
}
